/* globals require, console, gtag, window, $ */
'use strict';

const bezierEasing = require('bezier-easing');

const autosize = require('autosize/dist/autosize');

Math.radians = function (degrees) {
  return (degrees * Math.PI) / 180;
};

Math.degrees = function (radians) {
  return (radians * 180) / Math.PI;
};

Math.clamp = function (val, min, max) {
  return Math.min(Math.max(val, min), max);
};

$(function () {
  $('html').css('background-color', $('body').css('background-color'));
  let shapes = [
    [$('.who-are-you canvas').get(0), drawWhoAreYou],
    [$('.independence canvas').get(0), drawIndependence],
    [$('.costs canvas').get(0), drawCosts],
    [$('.how canvas').get(0), drawHow],
  ];

  for (let shape of shapes) {
    let c = shape[0];
    let f = shape[1];
    let df = f(c, 100);
    let sf = function () {
      let rect = c.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;
      elemBottom = elemTop + (elemBottom - elemTop) * 0.8;
      let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
      if (visible) {
        $(window).unbind('scroll', sf);
        window.requestAnimationFrame(df);
      }
    };
    $(window).bind('scroll', sf);
  }

  let teamMembers = {
    ann: {
      canvas: $('.team-ann canvas').get(0),
      images: [
        require('../images/wm-team-ann.png'),
        require('../images/wm-team-ann-shadow.png'),
      ],
      frames: ['breaking', 'knot'],
    },
    anders: {
      canvas: $('.team-anders canvas').get(0),
      images: [
        require('../images/wm-team-anders.png'),
        require('../images/wm-team-anders-shadow.png'),
      ],
      frames: ['u', 'mirroredl', 'mirroredl2'],
    },
  };

  for (let member of Object.values(teamMembers)) {
    let df = drawTeamMember(
      member.canvas,
      member.images[0],
      member.images[1],
      member.frames,
    );
    let sf = function () {
      let rect = member.canvas.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;
      elemBottom = elemTop + (elemBottom - elemTop) * 0.6;
      let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
      if (visible) {
        $(window).unbind('scroll', sf);
        window.requestAnimationFrame(df);
      }
    };
    $(window).bind('scroll', sf);
  }

  appears($('.app-shot'), 0.3, function (elem) {
    elem.addClass('loaded');
  });

  let textSizeCanvas = document.createElement('canvas');
  let textSizeContext = textSizeCanvas.getContext('2d');
  function getTextWidth(text, font) {
    textSizeContext.font = font;
    let metrics = textSizeContext.measureText(text);
    return metrics.width;
  }
  const fontProps = [
    'font-style',
    'font-variant',
    'font-weight',
    'font-size',
    'font-family',
  ];
  $('.lets-talk .text-field').on('input', function () {
    $(this)
      .removeClass('empty not-empty')
      .addClass($(this).val() ? 'not-empty' : 'empty');
    let cs = window.getComputedStyle(this, null);
    let font = [];
    for (let fp of fontProps) {
      font.push(cs.getPropertyValue(fp));
    }
    let w = getTextWidth($(this).val(), font.join(' '));

    $(this)
      .nextAll('.text-progress:eq(0)')
      .find('span')
      .css('width', w + 'px');
  });
  $('.lets-talk .text-field').trigger('input');
  autosize($('.lets-talk textarea'));

  let form = $('.lets-talk form');
  form.on('submit', function (e) {
    /* eslint-disable camelcase */
    gtag('event', 'wm-request-sent', {
      event_category: 'reading',
      event_label: 'Wealth Management',
    });
    /* eslint-enable camelcase */

    window.adf && window.adf.ClickTrack(this, 1342781, 'Skicka formulär', {}); //Tracking
    let data = form.serializeArray();
    $.post('/wealth/kontakt', data)
      .done(function (data) {
        console.log('data /wealth/kontakt', data);
        if (data.error) {
          form.addClass('error');
          form.removeClass('submitted');
        }
      })
      .fail(function (error) {
        console.error('error post to /wealth/kontakt', error);
        form.addClass('error');
        form.removeClass('submitted');
      });
    form.addClass('submitted');
    $(form).find('textarea, input').prop('disabled', true);
    e.preventDefault();
  });

  // Prevent form submission with enter key
  let inputs = form.find(
    'input:text, input[type=password], input[type=email], textarea',
  );
  form.on(
    'keydown',
    'input:text, input[type=password], input[type=email]',
    function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        let current = inputs.index(e.target);
        let next = inputs.eq(current + 1).length
          ? inputs.eq(current + 1)
          : null;
        if (next) {
          next.focus();
        }
        return false;
      }
    },
  );

  $('.testimonials__list').slick({
    // normal options...
    dots: true,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: false,
    autoplay: false,
    autoplaySpeed: 5000,
    prevArrow: '.testimonials__nav--prev',
    nextArrow: '.testimonials__nav--next',
    appendDots: '.testimonials__dots',

    // the magic
    // responsive: [{
    //
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 1,
    //     infinite: true
    //   }
    //
    // }, {
    //
    //   breakpoint: 600,
    //   settings: {
    //     slidesToShow: 2,
    //     dots: true
    //   }
    //
    // }]
  });

  $('#interested').click(function (e) {
    e.preventDefault();
    let position = $('#lets-talk').offset().top - 60;
    $('html,body').animate({ scrollTop: position }, 'slow');
  });
});

function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}

function drawWhoAreYou(canvas, startDelay = 300) {
  let ctx = canvas.getContext('2d');
  scaleCanvas(canvas, ctx);
  let start = null;
  const duration = 1300;
  const fullScale = 0.7;
  const smallScale = 0.2;
  const overShootEasing = bezierEasing(0.17, 0.67, 0.42, 1.6);

  function drawBase(w, h, tp, p) {
    let fp = localProgress(p, 0, 0.4);
    p = easeInOutQuart(p);
    const ss = w * (smallScale + (fullScale - smallScale) * p); // Square size
    const hss = ss / 2; // Half square size

    ctx.save();
    ctx.clearRect(0, 0, w, h);
    ctx.globalAlpha = fp;
    ctx.fillStyle = '#1c1c1c';
    ctx.translate(w / 2, h / 2); // Move the origin to the center of canvas
    ctx.rotate(Math.radians(90 - 90 * p));
    ctx.beginPath();
    ctx.moveTo(-hss + hss * p, -hss);
    ctx.lineTo(hss - hss * p, -hss);
    ctx.lineTo(hss, hss);
    ctx.lineTo(-hss, hss);
    ctx.fill();
    ctx.restore();
  }

  function drawTop(w, h, tp, p) {
    p = overShootEasing(p);
    if (p === 0) {
      return;
    }
    const cx = w / 2; // Center of canvas
    const ty = (h - h * fullScale) / 2; // Top of the triangle
    const targetSize = 0.1; // Size relative to the full scale triangle

    ctx.save();
    ctx.fillStyle = 'hsl(5, 71%, 73%)';
    ctx.beginPath();
    ctx.moveTo(cx, ty);
    ctx.lineTo(
      cx + (w / 2) * fullScale * targetSize * p,
      ty + w * fullScale * targetSize * p,
    );
    ctx.lineTo(
      cx - (w / 2) * fullScale * targetSize * p,
      ty + w * fullScale * targetSize * p,
    );
    ctx.fill();
    ctx.restore();

    ctx.save();
    let gradient = ctx.createRadialGradient(cx, ty, ty * p, cx + 0.001, ty, 0);
    gradient.addColorStop(0, 'rgba(255, 213, 209, 0)');
    gradient.addColorStop(1, 'rgba(255, 213, 209, 0.04)');
    ctx.fillStyle = gradient;
    ctx.fillRect(cx - ty, 0, ty * 2, ty * 2);
    ctx.restore();
  }

  function draw(timestamp) {
    if (!start) {
      start = timestamp;
    }
    let p =
      start === null
        ? 0
        : Math.clamp((timestamp - start - startDelay) / duration, 0, 1);
    const w = canvas.width;
    const h = canvas.height;

    drawBase(w, h, p, localProgress(p, 0, 0.7));
    drawTop(w, h, p, localProgress(p, 0.6, 1));
    if (p < 1 && start !== null) {
      window.requestAnimationFrame(draw);
    }
  }

  draw(null);
  return draw;
}

function drawIndependence(canvas, startDelay = 300) {
  let ctx = canvas.getContext('2d');
  scaleCanvas(canvas, ctx);
  let start = null;
  const duration = 2000;
  const overShootEasing = bezierEasing(0.74, -1.3, 0.59, 1.62);

  function drawBase(w, h, tp, p) {
    let fp = localProgress(p, 0, 0.4);
    const progress = p; //easeInOutQuart(p)
    ctx.clearRect(0, 0, w, h);
    ctx.save();
    ctx.globalAlpha = fp;
    const baseColor = { h: 0, s: 0, l: 14 };
    const accentColor = { h: 5, s: 71, l: 73 };
    ctx.fillStyle = formatHSL(baseColor);
    const squares = 6;
    const squareSize = w / squares;
    const squareDelay = 0.01; // Start delay for every square (in percent of progress)
    const bigSquareAnimation = 0.2;
    const k = 0.5522847498307933984022516322796 * Math.sin(Math.radians(45));
    // Time left after the last square has started animating, this is the animation time for each square
    const squareAnimDuration =
      1 - (squares * squares - 1) * squareDelay - bigSquareAnimation;

    for (let x = 0; x < squares; x++) {
      for (let y = 0; y < squares; y++) {
        const i = y * squares + x;

        ctx.save();
        ctx.translate(
          squareSize * x + squareSize / 2,
          squareSize * y + squareSize / 2,
        );
        if (x >= 2 && x <= 3 && y >= 2 && y <= 3) {
          if (x === 2 && y === 2) {
            const bsp = Math.clamp(
              (progress -
                (squares * squares * squareDelay + bigSquareAnimation)) /
                squareAnimDuration,
              0,
              1,
            );
            const colorP = Math.clamp((bsp - 0.7) / 0.3, 0, 1);
            const p = overShootEasing(
              Math.clamp(
                (progress -
                  (squares * squares * squareDelay + bigSquareAnimation)) /
                  squareAnimDuration,
                0,
                1,
              ),
            );
            const ss =
              squareSize * 2 - (squareSize * 2 - squareSize * 0.45) * p;
            const hss = ss / 2;
            const r = Math.sqrt(Math.pow(ss, 2) + Math.pow(ss, 2)) / 2;
            const cpd = r * k * colorP; // Control point distance from path point
            ctx.translate(squareSize / 2, squareSize / 2);
            let gradient = ctx.createRadialGradient(
              0,
              0,
              squareSize * colorP,
              0.001,
              0,
              0,
            );
            gradient.addColorStop(0, 'rgba(255, 213, 209, 0)');
            gradient.addColorStop(1, 'rgba(255, 213, 209, 0.05)');
            ctx.fillStyle = gradient;
            ctx.fillRect(
              -squareSize,
              -squareSize,
              squareSize * 2,
              squareSize * 2,
            );
            ctx.rotate(Math.radians(70) * p);
            ctx.beginPath();
            ctx.moveTo(-hss, -hss);
            ctx.fillStyle = formatHSL(
              transitionHSL(baseColor, accentColor, colorP),
            );
            ctx.bezierCurveTo(
              -hss + cpd,
              -hss - cpd,
              hss - cpd,
              -hss - cpd,
              hss,
              -hss,
            );
            ctx.bezierCurveTo(
              hss + cpd,
              -hss + cpd,
              hss + cpd,
              hss - cpd,
              hss,
              hss,
            );
            ctx.bezierCurveTo(
              hss - cpd,
              hss + cpd,
              -hss + cpd,
              hss + cpd,
              -hss,
              hss,
            );
            ctx.bezierCurveTo(
              -hss - cpd,
              hss - cpd,
              -hss - cpd,
              -hss + cpd,
              -hss,
              -hss,
            );
            ctx.fill();
          }
        } else {
          const p = easeInOutQuart(
            Math.clamp((progress - i * squareDelay) / squareAnimDuration, 0, 1),
          );
          const ss = squareSize * 1.04 - squareSize * 0.65 * p;
          const hss = ss / 2;
          const r = Math.sqrt(Math.pow(ss, 2) + Math.pow(ss, 2)) / 2;
          const cpd = r * k * p; // Control point distance from path point
          ctx.rotate(Math.radians(-70) * p);
          ctx.beginPath();
          ctx.moveTo(-hss, -hss);
          ctx.bezierCurveTo(
            -hss + cpd,
            -hss - cpd,
            hss - cpd,
            -hss - cpd,
            hss,
            -hss,
          );
          ctx.bezierCurveTo(
            hss + cpd,
            -hss + cpd,
            hss + cpd,
            hss - cpd,
            hss,
            hss,
          );
          ctx.bezierCurveTo(
            hss - cpd,
            hss + cpd,
            -hss + cpd,
            hss + cpd,
            -hss,
            hss,
          );
          ctx.bezierCurveTo(
            -hss - cpd,
            hss - cpd,
            -hss - cpd,
            -hss + cpd,
            -hss,
            -hss,
          );
          ctx.fill();
        }

        ctx.restore();
      }
    }
    ctx.restore();
  }

  function draw(timestamp) {
    if (!start) {
      start = timestamp;
    }
    let p =
      start === null
        ? 0
        : Math.clamp((timestamp - start - startDelay) / duration, 0, 1);
    const w = canvas.width;
    const h = canvas.height;

    drawBase(w, h, p, localProgress(p, 0, 1));
    if (p < 1 && start !== null) {
      window.requestAnimationFrame(draw);
    }
  }

  draw(null);
  return draw;
}

function drawCosts(canvas, startDelay = 300) {
  let ctx = canvas.getContext('2d');
  scaleCanvas(canvas, ctx);
  let start = null;
  const duration = 1300;
  const fullScale = 0.6;
  const smallScale = 0.2;
  const smallSquareEndScale = 0.07;
  const smallSquareStartScale = 0.25;
  //const overShootEasing = bezierEasing(.17, .67 ,.42 ,1.6)
  const accentStartColor = { h: 5, s: 71, l: 73, a: 0 };
  const accentEndColor = { h: 5, s: 71, l: 73, a: 1 };

  function drawBase(w, h, tp, p) {
    let fp = localProgress(p, 0, 0.4);
    p = easeInOutQuart(p);
    const ss = w * (smallScale + (fullScale - smallScale) * p); // Square size
    const hss = ss / 2; // Half square size

    ctx.save();
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#1c1c1c';
    ctx.globalAlpha = fp;
    ctx.translate(w / 2, h / 2); // Move the origin to the center of canvas
    ctx.rotate(Math.radians(20 - 65 * p));
    ctx.beginPath();
    ctx.moveTo(-hss, -hss);
    ctx.lineTo(hss, -hss);
    ctx.lineTo(hss, hss);
    ctx.lineTo(-hss, hss);
    ctx.fill();

    const sss = ss * interpolate(smallSquareStartScale, smallSquareEndScale, p);
    ctx.fillStyle = formatHSL(
      transitionHSL(accentStartColor, accentEndColor, p),
    );
    ctx.beginPath();
    ctx.translate(0, -(hss * 2 - sss) * p);
    ctx.moveTo(-hss, hss);
    ctx.lineTo(-hss, hss - sss);
    ctx.lineTo(-hss + sss, hss - sss);
    ctx.lineTo(-hss + sss, hss);
    ctx.fill();

    let gradient = ctx.createRadialGradient(
      -hss + sss / 2,
      hss - sss / 2,
      sss * 3 * p,
      -hss + sss / 2 + 0.001,
      hss - sss / 2,
      0,
    );
    gradient.addColorStop(0, 'rgba(255, 213, 209, 0)');
    gradient.addColorStop(1, 'rgba(255, 213, 209, 0.04)');
    ctx.fillStyle = gradient;
    ctx.fillRect(
      -hss + sss / 2 - sss * 3 * p,
      hss - sss / 2 - sss * 3 * p,
      sss * 3 * 2 * p,
      sss * 3 * 2 * p,
    );

    ctx.restore();
  }

  function draw(timestamp) {
    if (!start) {
      start = timestamp;
    }
    let p =
      start === null
        ? 0
        : Math.clamp((timestamp - start - startDelay) / duration, 0, 1);
    const w = canvas.width;
    const h = canvas.height;

    drawBase(w, h, p, p);
    if (p < 1 && start !== null) {
      window.requestAnimationFrame(draw);
    }
  }

  draw(null);
  return draw;
}

function drawHow(canvas, startDelay = 300) {
  let ctx = canvas.getContext('2d');
  scaleCanvas(canvas, ctx);
  let start = null;
  const duration = 2300;
  const overShootEasing = bezierEasing(0.17, 0.67, 0.42, 1.6);
  const accentColor = formatHSL({ h: 5, s: 71, l: 73 });

  function drawCircle(w, h, tp, p, scale, alpha) {
    p = easeInOutQuart(p);
    ctx.save();
    ctx.fillStyle = 'rgba(255, 255, 255, ' + alpha + ')';
    ctx.translate(w / 2, h / 2); // Move the origin to the center of canvas
    ctx.beginPath();
    ctx.arc(0, 0, (w / 2) * scale * p, 0, 2 * Math.PI);
    ctx.fill();
    ctx.restore();
  }

  function drawCherry(w, h, tp, p) {
    p = overShootEasing(p);
    const glowScale = 0.4;
    ctx.save();
    ctx.fillStyle = accentColor;
    ctx.translate(w / 2, h / 2); // Move the origin to the center of canvas
    ctx.beginPath();
    ctx.arc(0, 0, (w / 2) * 0.1 * p, 0, 2 * Math.PI);
    ctx.fill();
    let gradient = ctx.createRadialGradient(
      0,
      0,
      (w / 2) * glowScale * p,
      0.001,
      0,
      0,
    );
    gradient.addColorStop(0, 'rgba(255, 213, 209, 0)');
    gradient.addColorStop(1, 'rgba(255, 213, 209, 0.05)');
    ctx.fillStyle = gradient;
    ctx.fillRect(
      (-w / 2) * glowScale * p,
      (-w / 2) * glowScale * p,
      w * glowScale * p,
      w * glowScale * p,
    );
    ctx.restore();
    ctx.restore();
  }

  function draw(timestamp) {
    if (!start) {
      start = timestamp;
    }
    let p =
      start === null
        ? 0
        : Math.clamp((timestamp - start - startDelay) / duration, 0, 1);
    const w = canvas.width;
    const h = canvas.height;

    ctx.clearRect(0, 0, w, h);
    drawCircle(w, h, p, localProgress(p, 0.0, 0.35), 1, 0.01);
    drawCircle(w, h, p, localProgress(p, 0.0, 0.6), 0.75, 0.02);
    drawCircle(w, h, p, localProgress(p, 0.1, 0.8), 0.4, 0.02);
    drawCherry(w, h, p, localProgress(p, 0.7, 1.0));

    if (p < 1 && start !== null) {
      window.requestAnimationFrame(draw);
    }
  }

  draw(null);
  return draw;
}

function drawTeamMember(canvas, photoSrc, shadowSrc, frames) {
  const startDelay = 0;
  const duration = 1200;
  let ctx = canvas.getContext('2d');
  ctx.strokeStyle = 'rgb(255, 255, 255)';
  ctx.strokeWidth = 2;
  let start = null;
  let imgQueue = 2;
  const rectSize = 210;
  const sideLength = Math.sin(Math.radians(45)) * rectSize;

  let photo = new Image();
  photo.onload = function () {
    photo.loaded = true;
    imgQueue--;
    draw(null);
  };
  photo.src = photoSrc;

  let shadow = new Image();
  shadow.onload = function () {
    shadow.loaded = true;
    imgQueue--;
    draw(null);
  };
  shadow.src = shadowSrc;

  const frameFuncs = {
    static: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 46 * p);
      ctx.beginPath();
      ctx.moveTo(0, sideLength + p * 1);
      ctx.lineTo(sideLength, 0);
      ctx.lineTo(0, -sideLength);
      ctx.lineTo(-sideLength, 0);
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    },
    breaking: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 46 * p);
      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(0, sideLength);
      ctx.lineTo(-sideLength, 0);
      let lp = localProgress(p, 0.5, 1);
      ctx.lineTo((-sideLength / 2) * lp, -sideLength + (sideLength / 2) * lp);
      lp = localProgress(p, 0, 0.5);
      if (lp < 1) {
        ctx.lineTo(sideLength - sideLength * lp, -sideLength * lp);
      }
      ctx.stroke();
      ctx.restore();
    },
    breaking2: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 46 * p);

      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(sideLength * 0.5 * p, sideLength - sideLength * 0.5 * p);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, sideLength);
      ctx.lineTo(-sideLength, 0);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(-sideLength, 0);
      ctx.lineTo(-sideLength * 0.6 * p, -sideLength + sideLength * 0.6 * p);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, -sideLength);
      ctx.lineTo(sideLength - sideLength * p, -sideLength * p);
      ctx.stroke();

      ctx.restore();
    },
    knot: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 90 * p);
      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(sideLength * 0.2, sideLength - sideLength * 0.2);
      ctx.lineTo(0, sideLength - p * 66);
      ctx.lineTo(-sideLength * 0.2, sideLength - sideLength * 0.2);
      ctx.lineTo(-sideLength, 0);
      ctx.lineTo(sideLength * 0.4 * p, -sideLength - sideLength * 0.4 * p);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(sideLength * 0.2 * p, -sideLength - sideLength * 0.2 * p);
      ctx.stroke();
      ctx.restore();
    },
    knot2: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 90 * p);
      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(0, sideLength);
      ctx.lineTo(-sideLength, 0);
      ctx.lineTo(sideLength * 0.4 * p, -sideLength - sideLength * 0.4 * p);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(sideLength + sideLength * 0.15 * p, -sideLength * 0.15 * p);
      ctx.lineTo(sideLength * 0.2 * p, -sideLength - sideLength * 0.2 * p);
      ctx.stroke();
      ctx.restore();
    },
    u: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 46 * p);

      ctx.beginPath();
      ctx.moveTo(sideLength, 0);
      ctx.lineTo(0, sideLength);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, sideLength);
      ctx.lineTo(-sideLength, 0);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(-sideLength + sideLength * p, 0);
      ctx.lineTo(0, -sideLength + sideLength * p);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(
        0 - sideLength * 0.15 * p,
        -sideLength - sideLength * 0.15 * p,
      );
      ctx.lineTo(sideLength, 0);
      ctx.stroke();

      ctx.restore();
    },
    mirroredl: function (p) {
      p = easeInOutQuart(p);
      ctx.save();
      ctx.translate(0, 90 * p);

      let lp = localProgress(p, 0.7, 1);
      ctx.beginPath();
      ctx.moveTo(sideLength, 0);
      ctx.lineTo(sideLength * 0.5 * lp, sideLength - sideLength * 0.5 * lp);
      ctx.stroke();

      lp = localProgress(p, 0.35, 0.7);
      if (lp < 1) {
        ctx.beginPath();
        ctx.moveTo(0, sideLength);
        ctx.lineTo(-sideLength + sideLength * lp, sideLength * lp);
        ctx.stroke();
      }

      lp = localProgress(p, 0.0, 0.35);
      if (lp < 1) {
        ctx.beginPath();
        ctx.moveTo(-sideLength, 0);
        ctx.lineTo(0 - sideLength * lp, -sideLength + sideLength * lp);
        ctx.stroke();
      }

      ctx.beginPath();
      ctx.moveTo(0 - sideLength * 0.2 * p, -sideLength - sideLength * 0.2 * p);
      ctx.lineTo(sideLength, 0);
      ctx.stroke();

      ctx.restore();
    },
    mirroredl2: function (p) {
      p = easeInOutQuart(p);
      ctx.save();

      let lp = localProgress(p, 0.7, 1);
      ctx.beginPath();
      ctx.moveTo(sideLength, 0);
      ctx.lineTo(sideLength * 0.3 * lp, sideLength - sideLength * 0.3 * lp);
      ctx.stroke();

      lp = localProgress(p, 0.35, 0.7);
      if (lp < 1) {
        ctx.beginPath();
        ctx.moveTo(0, sideLength);
        ctx.lineTo(-sideLength + sideLength * lp, sideLength * lp);
        ctx.stroke();
      }

      lp = localProgress(p, 0.0, 0.35);
      if (lp < 1) {
        ctx.beginPath();
        ctx.moveTo(-sideLength, 0);
        ctx.lineTo(0 - sideLength * lp, -sideLength + sideLength * lp);
        ctx.stroke();
      }

      ctx.beginPath();
      ctx.moveTo(sideLength * 0.2 * p, -sideLength + sideLength * 0.2 * p);
      ctx.lineTo(sideLength, 0);
      ctx.stroke();

      ctx.restore();
    },
  };

  for (let frame of frames) {
    if (!frameFuncs[frame]) {
      console.warn(
        'Use of non-existing frame detected: "' + frame + '", skipping.',
      );
    }
  }

  function drawImage(w, h, tp, p) {
    ctx.save();
    ctx.clearRect(0, 0, w, h);
    ctx.translate(w / 2, h / 2 - easeInOutQuart(p) * 32); // Move the origin to the center of canvas

    if (shadow.loaded) {
      ctx.save();
      ctx.globalAlpha = 1 * easeInOutQuart(p);
      ctx.drawImage(shadow, -shadow.width / 2, -shadow.height / 2);
      ctx.restore();
    }
    ctx.save();
    ctx.translate(0, h / 2 - 61 - sideLength); // Move origin to center of the square frame
    ctx.globalAlpha = 0.05;
    for (let frame of frames) {
      frameFuncs[frame] && frameFuncs[frame](p);
    }
    ctx.restore();
    if (photo.loaded) {
      ctx.drawImage(photo, -photo.width / 2, -photo.height / 2);
    }
    ctx.restore();
  }

  function draw(timestamp) {
    if (!start) {
      start = timestamp;
    }
    let p =
      start === null
        ? 0
        : Math.clamp((timestamp - start - startDelay) / duration, 0, 1);
    const w = canvas.width;
    const h = canvas.height;

    drawImage(w, h, p, p);
    if (p < 1 && imgQueue === 0 && start !== null) {
      window.requestAnimationFrame(draw);
    }
  }

  draw(null);
  return draw;
}

function formatHSL({ h, s, l, a }) {
  if (!isFinite(a)) {
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
  }
  return 'hsla(' + h + ', ' + s + '%, ' + l + '%, ' + a + ')';
}

function transitionHSL(start, end, progress) {
  return {
    h: interpolate(start.h, end.h, progress),
    s: interpolate(start.s, end.s, progress),
    l: interpolate(start.l, end.l, progress),
    a: interpolate(
      isFinite(start.a) ? start.a : 1,
      isFinite(end.a) ? end.a : 1,
      progress,
    ),
  };
}

function localProgress(p, start, end) {
  return Math.clamp((p - start) / (end - start), 0, 1);
}

function interpolate(start, end, progress) {
  return end > start
    ? start + (end - start) * progress
    : start - (start - end) * progress;
}

function scaleCanvas(canvas, context) {
  // assume the device pixel ratio is 1 if the browser doesn't specify it
  const devicePixelRatio = window.devicePixelRatio || 1;

  // determine the 'backing store ratio' of the canvas context
  const backingStoreRatio =
    context.webkitBackingStorePixelRatio ||
    context.mozBackingStorePixelRatio ||
    context.msBackingStorePixelRatio ||
    context.oBackingStorePixelRatio ||
    context.backingStorePixelRatio ||
    1;

  // determine the actual ratio we want to draw at
  const ratio = devicePixelRatio / backingStoreRatio;

  if (devicePixelRatio !== backingStoreRatio) {
    // set the 'real' canvas size to the higher width/height
    let w = canvas.width;
    let h = canvas.height;
    canvas.width = w * ratio;
    canvas.height = h * ratio;

    // ...then scale it back down with CSS
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
  }

  return ratio;
}

function appears(elem, visibilityPercentage, f) {
  let sf = function () {
    let rect =
      elem instanceof jQuery
        ? elem[0].getBoundingClientRect()
        : elem.getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    elemBottom = elemTop + (elemBottom - elemTop) * (visibilityPercentage || 1);
    let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
    if (visible) {
      $(window).unbind('scroll', sf);
      f(elem);
    }
  };
  $(window).bind('scroll', sf);
}
